import { Component } from '@angular/core';
import {SecurityRequestService} from '../../../../services/security-request.service';
import {AdminSettingsService} from '../../../../services/admin-settings.service';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {SecurityRequestStatus, SecurityRequestType} from '../../../../types/security-requests';
import {switchMap} from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import {
  SecurityRequestStatusDialogComponent
} from '../../../pages/encryption/security-request-status-dialog/security-request-status-dialog.component';
import {RestConfigService} from '../../../../services/config-service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-security-requests-status-list-dialog',
    templateUrl: './security-requests-status-list-dialog.component.html',
    styleUrl: './security-requests-status-list-dialog.component.scss',
    standalone: false
})
export class SecurityRequestsStatusListDialogComponent {

  securityRequests$ = this.securityRequestService.getRequests();

  columns = ['created', 'type', 'target_email']

  constructor(public dialogRef: MatDialogRef<SecurityRequestsStatusListDialogComponent>,
              private readonly securityRequestService: SecurityRequestService,
              private readonly dialog: MatDialog,
              private readonly restConfigService: RestConfigService,
              private readonly translateService: TranslateService,
              private readonly adminSettingsService: AdminSettingsService) {
  }

  onClose() {
    this.dialogRef.close();
  }

  showRequestStatus(requestId: number) {
    forkJoin([
      this.securityRequestService.getApproversStatus(requestId),
      this.adminSettingsService.getAdminSettings(),
      this.restConfigService.getRestConfig(),
    ]).pipe(
      switchMap(([response, adminSettings, restConfig]) => {
        const dialogData = {
          results: response.results,
          minimumApprovalPercentRequired: restConfig.security_request_min_percent,
          securityApprovalMethod: adminSettings.security_approval_method,
          dialogTitle: this.translateService.instant('security-request-status.dialog-title'),
        };
        return this.dialog.open(SecurityRequestStatusDialogComponent, {width: '44em', data: dialogData}).afterClosed();
      })
    ).subscribe();
  }

  readonly SecurityRequestType = SecurityRequestType;
  readonly SecurityRequestStatus = SecurityRequestStatus;
}
